import api from './api';

export const programService = {
  getAllPrograms: (params) => api.get('/programs', { params }),
  getProgramById: (id) => api.get(`/programs/${id}`),
  createProgram: (programData) => api.post('/programs', programData),
  updateProgram: (id, programData) => api.put(`/programs/${id}`, programData),
  deleteProgram: (id) => api.delete(`/programs/${id}`),
  getLiveProgram: () => api.get('/programs/live'),
  getScheduleByDay: (day) => api.get(`/programs/schedule/${day}`),
  getProgrammingByDay: (day) => api.get(`/programs/schedule/${day}`),
  getActiveProgramsWithBanners: () => api.get('/programs/active-with-banners'),
  uploadBanner: (programId, formData) => api.post(`/programs/${programId}/banner`, formData),
  removeBanner: (programId) => api.delete(`/programs/${programId}/banner`),
};
